import { Table, Callout, ScrollArea, Box, Text } from '@radix-ui/themes';
import * as yup from 'yup';
import { useEffect, useState } from 'react';

const schema = yup.object().shape({

});

interface ExcelRow {

}

type ValidatedRow = ExcelRow & {
  errors: Record<string, string>;
};

interface Props {
  rawData: ExcelRow[];
  onValidRowsChange?: (validRows: Omit<ValidatedRow, 'errors'>[]) => void;
}

const ExcelPreviewTable = ({ rawData, onValidRowsChange }: Props) => {
  const [validatedData, setValidatedData] = useState<ValidatedRow[]>([]);

  useEffect(() => {
    const processData = async () => {
      const processed: ValidatedRow[] = await Promise.all(
        rawData.map(async (row) => {
          const convertedRow = {
            ...row,
          };

          try {
            await schema.validate(convertedRow, { abortEarly: false });
            return { ...convertedRow, errors: {} };
          } catch (err: any) {
            const errors: Record<string, string> = {};
            err.inner.forEach((e: any) => {
              errors[e.path] = e.message;
            });
            return { ...convertedRow, errors };
          }
        })
      );
      setValidatedData(processed);

      onValidRowsChange?.(processed.filter((r) => Object.keys(r.errors).length === 0));
    };

    processData();
  }, [rawData]);

  if (validatedData.length === 0) return <Text>Nenhum dado a exibir</Text>;

  const headers = Object.keys(validatedData[0]).filter((key) => key !== 'errors');

  return (
    <ScrollArea type="always" scrollbars="horizontal">
      <Table.Root variant="surface">
        <Table.Header>
          <Table.Row>
            {headers.map((header) => (
              <Table.ColumnHeaderCell key={header}>{header}</Table.ColumnHeaderCell>
            ))}
            <Table.ColumnHeaderCell>Erros</Table.ColumnHeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {validatedData.map((row, index) => (
            <Table.Row key={index}>
              {headers.map((key) => (
                <Table.Cell key={key}>
                  {String((row as any)[key])}
                </Table.Cell>
              ))}
              <Table.Cell>
                {Object.values(row.errors).map((err, i) => (
                  <Callout.Root key={i} color="red" style={{ marginBottom: 4 }}>
                    <Text size="1">{err}</Text>
                  </Callout.Root>
                ))}
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table.Root>
    </ScrollArea>
  );
};

export default ExcelPreviewTable;
